import * as React from "react";
import { useEffect, useRef, ReactNode } from 'react';
import { OrderItemProps, OrderProps } from "src/resources/sales/interface";
import {
    Typography
  } from "@mui/material";
  
interface ArticleTicketProps {
  record: OrderItemProps;
}

export const ArticleTicket = (props: ArticleTicketProps) => {
    const { record } = props
    let productParent = record.product.parent ?? record.product;

    return (
    <>
        <div className="fabric-detail-sheet__wrapper" style={{marginBottom: "20px"}}>
            <div className="fabric-detail-sheet__print-header">
                <div className="fabric-detail-sheet__header">
                    <div className="fabric-detail-sheet__title">
                        <Typography variant="h5" sx={{marginBottom: "10px"}}>Article Ticket</Typography>
                    </div>
                </div>
            </div>

            <div className="fabric-detail-sheet__table">
            <SheetRow
                label="Item"
                value={`${productParent.mill_name} - ${record.product.sku} (${productParent.name}/${record.product.name})`}
            />
            <SheetRow
                label="Content"
                value={`${productParent?.attributes?.content}`}
            />
            <SheetRow
                label="Width"
                value={`${productParent?.attributes?.width} in - ${productParent?.attributes?.fabric_width} cm`}
            />
            <SheetRow
                label="Quantity"
                value={`${record.quantity} yards - ${record.quantity*0.9144} meters`}
            />
            <SheetRow
                label="Country of Origin"
                value={productParent?.attributes?.country_of_manufacture}
            />
            </div>
        </div>
    </>
    );
};

const SheetRow = ({ label, value }: any) => {
  return (
    <div className="fabric-detail-sheet__table-row">
      <p className="fabric-detail__row-title">{label}:</p>
      {value ? <p>{value}</p> : null}
    </div>
  );
};
